import React, { useState } from 'react'
import contactUsBackground from 'assets/images/contact-us-background.jpeg'
import contactUsImage from 'assets/images/contact-us-image.jpeg'
import CustomerGetInTouchModal from 'components/modals/getHelp/CustomerGetInTouchModal'
import { config } from 'data/config'
import PartnerInquiryModal from 'components/PartnerInquiryModal'
import Image from 'components/Image'
import PublicLayout, { PublicLayoutProps } from 'layouts/PublicLayout'
import { useHasScrolled } from 'data/hooks/useHasScrolled'

const ContactUsPage = () => {
  const hasScrolled = useHasScrolled(0, true)
  const [modalOpen, setModalOpen] = useState(false)
  const [formModalOpen, setFormModalOpen] = useState(false)

  const seo: PublicLayoutProps['seo'] = {
    title: 'Contact A.M.A Selections for Luxury Holiday Villa Rentals in Spain, France & Italy',
    description: 'Contact A.M.A Selections at any time to find out more about availability & exact rates of our luxury holiday villas for rent in France, Spain & Italy.',
    openGraph: {
      type: 'business',
      url: config.appURL + '/contact-us',
    },
  }

  return (
    <PublicLayout
      seo={seo}
      mobileNavBar={{
        visible: hasScrolled,
        back: true,
        profileTrigger: true,
      }}
    >
      <div className="relative flex h-full min-h-[375px] lg:min-h-[790px]">
        <Image
          src={contactUsBackground}
          alt="Beautiful blue sea bay with white walled building"
          className="absolute inset-0 object-cover"
          layout="fill"
          priority
        />
        <h1 className="absolute left-0 right-0 bottom-[44%] text-center text-white font-bold font-serif text-32 md:text-42 lg:text-48 xl:text-60 leading-title tracking-title drop-shadow-title">
          Contact Us
        </h1>
      </div>

      <div className="relative -mt-20 antialiased bg-white md:static container-public md:my-50 lg:my-150 rounded-t-20">
        <div className="flex flex-col md:flex-row max-w-[1050px] mx-auto">
          <div className="flex flex-col w-full gap-25 md:gap-40 text-grey-800 my-50 text-14 md:text-16 md:pr-10 max-w-[510px]">
            <h4 className="font-serif font-bold text-32 md:text-36 lg:text-42 xl:text-48 tracking-title leading-title text-grey-900 md:-mb-15">Get in touch with us</h4>

            <p>Please feel free to contact us via one of the forms below or by phone. Our office hours vary depending on the season but you will always be able to reach us from: Monday to Friday, 10:00 - 18:00</p>

            <div>
              <p className="font-bold">For booking inquiries</p>
              <p>Send us a message <button className="underline text-primary" onClick={() => setModalOpen(true)}>here</button>.</p>
            </div>

            <div>
              <p className="font-bold">For partnership inquiries</p>
              <p>Complete <button
                className="underline g-recaptcha text-primary"
                onClick={() => setFormModalOpen(true)}
                data-action="submit"
              >this form</button> if you’d like to work with us as an owner or local partner.</p>
            </div>

            <div>
              <p className="font-bold">For press &amp; other inquiries</p>
              <p>Email us at <a className="underline text-primary" href={`mailto:${config.amaSelectionsEmail}`}>{config.amaSelectionsEmail}</a>.</p>
            </div>
          </div>

          <div className="relative flex justify-center w-screen -mx-20 sm:w-full sm:mx-auto md:mr-0 sm:pl-10 mb-75 md:mb-0 sm:max-w-[450px] min-h-[675px]">
            <Image
              className="object-cover rounded-4 h-[300px] w-full sm:h-full"
              src={contactUsImage}
              alt=""
              layout="fill"
            />
          </div>
        </div>
      </div>

      <CustomerGetInTouchModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />

      <PartnerInquiryModal isOpen={formModalOpen} onClose={() => setFormModalOpen(false)} />
    </PublicLayout>
  )
}

export default ContactUsPage
